import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getLatestResources, Resource } from '@/mocks/resources';
import { categoryMap } from '@/mocks/categories';

export default function LatestResources() {
  const [visibleCount, setVisibleCount] = useState(8);
  const allLatest = getLatestResources(50);
  const visibleResources = allLatest.slice(0, visibleCount);

  const copyMagnet = async (resource: Resource, e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(resource.magnet);
      const btn = e.currentTarget as HTMLButtonElement;
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<i class="ri-check-line"></i>';
      btn.classList.add('text-accent-600');
      setTimeout(() => {
        btn.innerHTML = originalHTML;
        btn.classList.remove('text-accent-600');
      }, 1500);
    } catch {
      // fallback
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新资源
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              实时更新，发现最新最热的磁力链接资源
            </p>
          </div>
        </div>

        <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-background-200/60 bg-background-100">
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">
                    资源名称
                  </th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 whitespace-nowrap hidden md:table-cell">
                    分类
                  </th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 whitespace-nowrap hidden sm:table-cell">
                    大小
                  </th>
                  <th className="text-left px-4 py-3 text-xs font-semibold text-foreground-500 whitespace-nowrap hidden lg:table-cell">
                    日期
                  </th>
                  <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">
                    做种
                  </th>
                  <th className="text-center px-4 py-3 text-xs font-semibold text-foreground-500 whitespace-nowrap hidden sm:table-cell">
                    下载
                  </th>
                  <th className="text-right px-4 py-3 text-xs font-semibold text-foreground-500 whitespace-nowrap">
                    操作
                  </th>
                </tr>
              </thead>
              <tbody>
                {visibleResources.map((resource) => {
                  const cat = categoryMap[resource.category];
                  return (
                    <tr
                      key={resource.id}
                      className="border-b border-background-200/60 hover:bg-background-100/50 transition-colors"
                    >
                      <td className="px-4 py-3.5">
                        <Link
                          to={`/article/${resource.id}`}
                          className="text-sm font-medium text-foreground-900 hover:text-primary-600 transition-colors line-clamp-1 cursor-pointer"
                        >
                          {resource.title}
                        </Link>
                        <div className="flex flex-wrap gap-1.5 mt-1">
                          {resource.tags.slice(0, 3).map((tag) => (
                            <span
                              key={tag}
                              className="px-1.5 py-0.5 rounded text-[10px] bg-secondary-100 text-secondary-700"
                            >
                              {tag}
                            </span>
                          ))}
                        </div>
                      </td>
                      <td className="px-4 py-3.5 hidden md:table-cell">
                        <span className="text-xs text-foreground-500 whitespace-nowrap">
                          {cat?.name || resource.category}
                        </span>
                      </td>
                      <td className="px-4 py-3.5 hidden sm:table-cell">
                        <span className="text-xs text-foreground-500 whitespace-nowrap">{resource.size}</span>
                      </td>
                      <td className="px-4 py-3.5 hidden lg:table-cell">
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{resource.date}</span>
                      </td>
                      <td className="px-4 py-3.5 text-center">
                        <span className="text-xs font-medium text-accent-600 whitespace-nowrap">
                          {resource.seeders.toLocaleString()}
                        </span>
                      </td>
                      <td className="px-4 py-3.5 text-center hidden sm:table-cell">
                        <span className="text-xs text-foreground-400 whitespace-nowrap">
                          {resource.leechers.toLocaleString()}
                        </span>
                      </td>
                      <td className="px-4 py-3.5 text-right">
                        <button
                          onClick={(e) => copyMagnet(resource, e)}
                          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 text-xs font-medium transition-colors whitespace-nowrap cursor-pointer"
                          title="复制磁力链接"
                        >
                          <i className="ri-file-copy-line"></i>
                          <span className="hidden sm:inline">复制</span>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {visibleCount < allLatest.length && (
          <div className="flex justify-center mt-8">
            <button
              onClick={() => setVisibleCount((prev) => Math.min(prev + 8, allLatest.length))}
              className="px-8 py-3 rounded-xl border-2 border-background-200 hover:border-primary-300 text-sm font-medium text-foreground-600 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              加载更多资源
              <i className="ri-arrow-down-s-line ml-1"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}